module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_carcasses.a6cfae8c.jpg";